import React, { useEffect, useState } from "react";
import Dialog from '@mui/material/Dialog';

const EnvSelectionPopup = (props) => {
    const { open, onClose } = props;

    const [showText, setShowText] = useState(false);
    const [selectedEnv, setSelectedEnv] = useState(localStorage.getItem('env_type') | '');

    const onClick = () => {
        setShowText(!showText);
    }

    // Initialize selected environment from localStorage on component mount
    useEffect(() => {
        const storedEnv = localStorage.getItem('env_type');
        if (storedEnv) {
            setSelectedEnv(storedEnv);
        }
    }, []);

    const handleEnvironmentSelect = (env) => {
        setSelectedEnv(env);
        localStorage.setItem('env_type', env);
        setShowText(false);

        // Reload page to apply environment change
        window.location.reload();
    };
    return (
        <Dialog className="envSelectionDrop" onClose={onClose} open={open}>
            <div className=" p-3">
                <label className="font-large mb-1">Select Version</label>
                <div onClick={onClick} className="backgroundColor-Disable dropdown-div rounded-pill" style={{ position: "relative" }} >

                    <label className="textColor-Type1 dropdown-font">
                        {selectedEnv ? (selectedEnv === 'Production' ? 'Production' : 'Sandbox') : 'Select an Environment'}
                    </label>

                    <div className="dropdown-innerdiv">
                        <img className={showText ? "floatRight rotate" : "floatRight"} src={process.env.PUBLIC_URL + '/Assets/icons/right-arrow.svg'} alt="arrow" />
                    </div>
                    {showText && <div className="backgroundColor-Type3 dropdown-optiondiv-2" >
                        <ul className="px-0">
                            <li
                                className={`options ${selectedEnv === 'Production' ? 'selected' : ''}`}
                                key="Production"
                                onClick={() => handleEnvironmentSelect('Production')}
                            >
                                <label className="floatleft px-3">Production</label>
                            </li>
                            <li
                                className={`options ${selectedEnv === 'sandbox' ? 'selected' : ''} `}
                                key="sandbox"
                                onClick={() => handleEnvironmentSelect('sandbox')}
                            >
                                <label className="floatleft px-3">Sandbox</label>
                            </li>
                        </ul>
                    </div>}
                </div>

            </div>
        </Dialog>

    )
};
export default EnvSelectionPopup;
